import { render, staticRenderFns } from "./InspectionsTable.vue?vue&type=template&id=443e3e53&scoped=true&"
import script from "./InspectionsTable.vue?vue&type=script&lang=js&"
export * from "./InspectionsTable.vue?vue&type=script&lang=js&"
import style0 from "./InspectionsTable.vue?vue&type=style&index=0&id=443e3e53&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443e3e53",
  null
  
)

export default component.exports